import React from 'react';
import { Col, Clearfix } from 'react-bootstrap';
import { forEach as _forEach } from 'lodash';

export default class ClientLocationImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      overStar: false,
      showEdit: false,
    };
  }

  getThumbFile = () => {
    let thumbFile;
    _forEach(this.props.image.getVariations(), variation => {
      if (variation.getVariationType() === 'thumb') {
        thumbFile = variation.getFile();
      }
    });

    return thumbFile;
  };

  checkDefault = () => {
    const { image, entity, locationIndex } = this.props;

    return !!(
      entity.getLocations()[locationIndex].getDefaultImg() &&
      entity
        .getLocations()
        [locationIndex].getDefaultImg()
        .getId() === image.getId()
    );
  };

  mouseStarOver = () => {
    this.setState({ overStar: true });
  };

  mouseStarOut = () => {
    this.setState({ overStar: false });
  };

  onDefaultClick = e => {
    e.preventDefault();

    const { setDefault } = this.props;
    setDefault();
  };

  onEditClick = e => {
    e.preventDefault();

    this.setState({ showEdit: true });
  };

  closeEdit = () => {
    this.setState({ showEdit: false });
  };

  onRemoveClick = e => {
    e.preventDefault();

    this.props.delete();
  };

  render() {
    const { image } = this.props;
    const { overStar } = this.state;

    const thumbFile = this.getThumbFile();
    const isDefault = this.checkDefault();

    return (
      <Col xs={12} sm={6} md={3}>
        <div className="gallery-item">
          <img src={thumbFile.getWebLink()} className="image-responsive-height" alt="" />
          <div className="overlayer bottom-left full-width">
            <div className="overlayer-wrapper item-info ">
              <div className="gradient-grey p-l-20 p-r-20 p-t-20 p-b-5">
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <p className="bold text-white fs-11 p-t-10" style={{ whiteSpace: 'nowrap' }}>
                    {image.getFileName()}
                  </p>
                </div>
                <div className="m-t-10">
                  <div className="pull-right m-t-10">
                    <a href="#edit" className="fs-14 text-white" onClick={this.onEditClick}>
                      <i className="fa fa-edit fa-2x" />
                    </a>

                    <a
                      href="#setDefault"
                      className="fs-14 text-white m-l-10"
                      onMouseOver={this.mouseStarOver}
                      onFocus={this.mouseStarOver}
                      onMouseOut={this.mouseStarOut}
                      onBlur={this.mouseStarOut}
                      onClick={this.onDefaultClick}
                    >
                      {overStar || isDefault ? (
                        <i className="fa fa-star fa-2x" style={{ color: '#f7ca18' }} />
                      ) : (
                        <i className="far fa-star fa-2x" />
                      )}
                    </a>

                    <a href="#remove" className="fs-14 text-danger m-l-10" onClick={this.onRemoveClick}>
                      <i className="fal fa-trash-alt fa-2x" />
                    </a>
                  </div>
                  <Clearfix />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id={'image-' + image.getId() + '-edit'}></div>
      </Col>
    );
  }
}
